export default {
  computed: {
    partnerData() {
      return this.$store.getters['profile/dashboard/partnerData'];
    }
  }
};
